import { styled } from '@mui/material/styles';

export const Container = styled('div')(({ theme, outlined, height }) => ({
  height: height || '400px',
  padding: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.border.radius,
  border: outlined ? theme.border.default : 'none',
}));

export const Image = styled('img')(({ theme }) => ({
  width: '200px',
  marginBottom: theme.spacing(3),
}));
